import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/creative-commons-nc-jp': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M247.7 8C103.6 8 0 124.8 0 256 0 392.4 111.8 504 247.7 504 377.9 504 496 403.2 496 256 496 117.2 388.5 8 247.7 8zM248.3 458.7C136.3 458.7 44.7 366.2 44.7 256 44.7 234.9 47.7 214.8 53.7 195.7L180.7 252.2H152.8V290.8H210.9L216.6 302.6V321.3H152.8V360H216.6V416H278.3V360H342.5V324.3L423.5 360.4C422 362.6 366.4 458.7 248.3 458.7zM335.9 321.4H278.3V302.7L281.2 297.1 335.9 321.4zM342.4 270V252.2H303.8L366.8 136.2H301L257.6 232.2 234.6 222 195 136.3H129.2L156.5 187.3 74.6 150.8C102.4 106.7 157.2 52.7 248.3 52.7 361.1 52.7 451.3 142.7 451.3 256.1 451.3 277.1 448.6 296.7 443.4 315.1L342.4 270z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/creative-commons-nc-jp.js
// module id = lfZS
// module chunks = 144